import { TermsModal } from '@cian/frontend-e2e-deal-component';
import React from 'react';
import { useSelector } from 'react-redux';
import { CreditInfoModalFooter } from 'shared/components/CreditInfoModalFooter';
import { ETestIds } from 'shared/constants/testIds';
import { useShortOfferTermsModal } from 'shared/hooks/useShortOfferTermsModal';
import { selectModalWindowRedirectParams } from 'shared/selectors/landing/selectModalWindowOfferParams';
import { mapCalculatorOfferModalToTermsModal } from 'shared/utils/offers/mapCalculatorOfferModalToTermsModal';

export const ShortOfferTermsModalContainer: React.FC = () => {
  const { isModalOpen, termsModalData, handleModalClose, handleFillApplicationClick } = useShortOfferTermsModal();
  const modalWindowRedirectParams = useSelector(selectModalWindowRedirectParams);

  if (!termsModalData) {
    return null;
  }

  const termsModalProps = mapCalculatorOfferModalToTermsModal(termsModalData.modal, termsModalData.iconPath);

  return (
    <div data-testid={ETestIds.ShortOfferTermsModal}>
      <TermsModal
        subtitle={termsModalProps.title}
        logo={termsModalProps.logo}
        title={termsModalProps.subtitle}
        terms={termsModalProps.terms}
        allTerms={termsModalProps.allTerms}
        documentsText={termsModalProps.documentsText ?? undefined}
        open={isModalOpen}
        onOpenChange={open => {
          if (!open) {
            handleModalClose();
          }
        }}
        footer={
          <CreditInfoModalFooter
            handleFillApplicationClick={handleFillApplicationClick}
            buttonText={modalWindowRedirectParams?.text}
            variant="redesign"
            testId={ETestIds.FillApplicationButtonOfferModal}
          />
        }
      />
    </div>
  );
};
